import { observer } from "mobx-react-lite";
import SpinnerLoader from '../../Loaders/SpinnerLoader';
import { useContext } from 'react';
import { Context } from '../../../index';
import { useTranslation } from 'react-i18next';
import DonateBonuses from "./DonateBonuses";

const Bonuses = () => {
    const { t } = useTranslation();
    const {store} = useContext(Context)
    const {isDepositBonusesLoaded, depositBonuses} = store
    
    return (
        <div className='banner_banner__RLSyt'>
                <div className="banner_bonusesWrapper">
                    {
                        isDepositBonusesLoaded ?
                        depositBonuses.length > 0 &&
                        <>
                            <div className="banner_bonusesTitle">
                                {t('main.header.bonusTitle')}
                            </div>
                            <DonateBonuses />
                        </>:
                        <SpinnerLoader />
                    }
                </div>
            <img className={`header__image ${!isDepositBonusesLoaded ? 'blur-5':''}`} src='/img/other/BonusBG.png'></img>
        </div>
    );
}

export default observer(Bonuses)